module.exports = __webpack_public_path__ + "media/src/images/icons/oval_14x-e811564d769d6152cb5c72b315d20f30.png";